import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "../ui/accordion";
import { Reveal } from "../Reveal";

const FAQS = [
  ["Are you a lender?", "No. We are a loan facilitation platform. Lending partners make every credit decision; we help you compare and apply."],
  ["Is applying free?", "Yes. Checking eligibility and applying through us is free. Any loan charges are set by the lender."],
  ["How is my data used?", "Only to process your enquiry and share it with lending partners, with your consent. You can withdraw consent any time."],
  ["Which loans do you cover?", "Personal, business, home, vehicle, loan against property and MSME schemes."],
  ["What is a consulting plan?", "An optional paid session with an in-house consultant to help you become loan-ready. It is guidance only and does not guarantee approval."],
  ["Can I get a refund on a plan?", "Yes, in full if no session has been used, within 7 days of purchase."],
];

export function Faq() {
  return (
    <section id="faq" className="bg-[#f4f5f6] py-16 md:py-24">
      <div className="max-w-[820px] mx-auto px-4 md:px-8">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.2em] font-extrabold text-[#f06400]">FAQ</p>
          <h2 className="mt-2 text-3xl md:text-4xl font-extrabold tracking-[-0.035em]">Good questions.</h2>
        </Reveal>
        <Reveal delay={100} className="mt-8">
          <Accordion type="single" collapsible className="bg-white rounded-[28px] px-5 border border-[#e1e2e5]" data-testid="faq-accordion">
            {FAQS.map(([q, a], i) => (
              <AccordionItem key={i} value={`q${i}`}>
                <AccordionTrigger className="text-left font-extrabold" data-testid={`faq-q-${i}`}>{q}</AccordionTrigger>
                <AccordionContent className="text-[#191c1f]/75 leading-relaxed">{a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
